export const data = [
  {
    SerialNum: 'Entity-21032022.csv',
    col3: '10100098233',
    col: 'Value',
    col0: 'Value',
    col4: 'Value',
    col5: 'Value',
    col2: 'Processed',
    col9: 'Something went wrong',
    col6: 'View_View',
  },
  {
    SerialNum: 'Entity-21032022.csv',
    col3: '10100098233',
    col: 'Value',
    col0: 'Value',
    col4: 'Value',
    col5: 'Value',
    col2: 'Processed',
    col9: '-',
    col6: 'View_View',
  },
  {
    SerialNum: 'Entity-21032022.csv',
    col3: '10100098233',
    col: 'Value',
    col0: 'Value',
    col4: 'Value',
    col5: 'Value',
    col2: 'Failed',
    col9: 'Something went wrong',
    col6: 'View_View',
  },
  {
    SerialNum: 'Entity-21032022.csv',
    col3: '10100098233',
    col: 'Value',
    col0: 'Value',
    col4: 'Value',
    col5: 'Value',
    col2: 'Processed',
    col9: 'Something went wrong',
    col6: 'View_View',
  },
  {
    SerialNum: 'Entity-21032022.csv',
    col3: '10100098233',
    col: 'Value',
    col0: 'Value',
    col4: 'Value',
    col5: 'Value',
    col2: 'Processed',
    col9: 'Something went wrong',
    col6: 'View_View',
  },
]

export const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
}

export const headerData = [
  {
    title: 'Request ID.',
  },
  {
    title: 'MID',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Upload Status',
  },
  {
    title: 'Failure Reason',
  },
  {
    title: 'Action',
  },
]
